export default __webpack_public_path__ + "static/media/Pickpocket's Jerkin of the Hidden Palace.6c874cb0.jpg";